// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Alert = require("../../common/Components/Alert.bs.js");
var React = require("react");
var V4 = require("uuid/v4");
var DialogV5 = require("../../../uikit/reason/molecules/Dialog/DialogV5.bs.js");
var ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var ConfirmDialog = require("../../../reason/common/ConfirmDialog/ConfirmDialog.bs.js");
var SystemMessages = require("../../../reason/systemMessages/SystemMessages.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
var UnselectedUnionMemberError = require("../../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
var MyClientsWidgetDeleteDialog_clientV5_graphql = require("../../../__generated__/MyClientsWidgetDeleteDialog_clientV5_graphql.bs.js");
var MyClientsWidgetDeleteDialog_mutations_deleteBuyerNeedMutation_graphql = require("../../../__generated__/MyClientsWidgetDeleteDialog_mutations_deleteBuyerNeedMutation_graphql.bs.js");
var MyClientsWidgetDeleteDialog_mutations_deleteRentalNeedMutation_graphql = require("../../../__generated__/MyClientsWidgetDeleteDialog_mutations_deleteRentalNeedMutation_graphql.bs.js");
var MyClientsWidgetDeleteDialog_mutations_deleteRentalPropertyMutation_graphql = require("../../../__generated__/MyClientsWidgetDeleteDialog_mutations_deleteRentalPropertyMutation_graphql.bs.js");
var MyClientsWidgetDeleteDialog_mutations_deleteForSalePropertyMutation_graphql = require("../../../__generated__/MyClientsWidgetDeleteDialog_mutations_deleteForSalePropertyMutation_graphql.bs.js");

var convertVariables = MyClientsWidgetDeleteDialog_mutations_deleteForSalePropertyMutation_graphql.Internal.convertVariables;

var convertResponse = MyClientsWidgetDeleteDialog_mutations_deleteForSalePropertyMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse = MyClientsWidgetDeleteDialog_mutations_deleteForSalePropertyMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, MyClientsWidgetDeleteDialog_mutations_deleteForSalePropertyMutation_graphql.node, convertResponse, convertWrapRawResponse);

var use = RescriptRelay_Mutation.useMutation(convertVariables, MyClientsWidgetDeleteDialog_mutations_deleteForSalePropertyMutation_graphql.node, convertResponse, convertWrapRawResponse);

var DeleteForSalePropertyMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

var convertVariables$1 = MyClientsWidgetDeleteDialog_mutations_deleteRentalPropertyMutation_graphql.Internal.convertVariables;

var convertResponse$1 = MyClientsWidgetDeleteDialog_mutations_deleteRentalPropertyMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse$1 = MyClientsWidgetDeleteDialog_mutations_deleteRentalPropertyMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation$1 = RescriptRelay_Mutation.commitMutation(convertVariables$1, MyClientsWidgetDeleteDialog_mutations_deleteRentalPropertyMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

var use$1 = RescriptRelay_Mutation.useMutation(convertVariables$1, MyClientsWidgetDeleteDialog_mutations_deleteRentalPropertyMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

var DeleteRentalPropertyMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  commitMutation: commitMutation$1,
  use: use$1
};

var convertVariables$2 = MyClientsWidgetDeleteDialog_mutations_deleteBuyerNeedMutation_graphql.Internal.convertVariables;

var convertResponse$2 = MyClientsWidgetDeleteDialog_mutations_deleteBuyerNeedMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse$2 = MyClientsWidgetDeleteDialog_mutations_deleteBuyerNeedMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation$2 = RescriptRelay_Mutation.commitMutation(convertVariables$2, MyClientsWidgetDeleteDialog_mutations_deleteBuyerNeedMutation_graphql.node, convertResponse$2, convertWrapRawResponse$2);

var use$2 = RescriptRelay_Mutation.useMutation(convertVariables$2, MyClientsWidgetDeleteDialog_mutations_deleteBuyerNeedMutation_graphql.node, convertResponse$2, convertWrapRawResponse$2);

var DeleteBuyerNeedMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$2,
  convertResponse: convertResponse$2,
  convertWrapRawResponse: convertWrapRawResponse$2,
  commitMutation: commitMutation$2,
  use: use$2
};

var convertVariables$3 = MyClientsWidgetDeleteDialog_mutations_deleteRentalNeedMutation_graphql.Internal.convertVariables;

var convertResponse$3 = MyClientsWidgetDeleteDialog_mutations_deleteRentalNeedMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse$3 = MyClientsWidgetDeleteDialog_mutations_deleteRentalNeedMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation$3 = RescriptRelay_Mutation.commitMutation(convertVariables$3, MyClientsWidgetDeleteDialog_mutations_deleteRentalNeedMutation_graphql.node, convertResponse$3, convertWrapRawResponse$3);

var use$3 = RescriptRelay_Mutation.useMutation(convertVariables$3, MyClientsWidgetDeleteDialog_mutations_deleteRentalNeedMutation_graphql.node, convertResponse$3, convertWrapRawResponse$3);

var DeleteRentalNeedMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$3,
  convertResponse: convertResponse$3,
  convertWrapRawResponse: convertWrapRawResponse$3,
  commitMutation: commitMutation$3,
  use: use$3
};

var Mutations = {
  DeleteForSalePropertyMutation: DeleteForSalePropertyMutation,
  DeleteRentalPropertyMutation: DeleteRentalPropertyMutation,
  DeleteBuyerNeedMutation: DeleteBuyerNeedMutation,
  DeleteRentalNeedMutation: DeleteRentalNeedMutation
};

var convertFragment = MyClientsWidgetDeleteDialog_clientV5_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetDeleteDialog_clientV5_graphql.node, convertFragment, fRef);
}

function use$4(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetDeleteDialog_clientV5_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, MyClientsWidgetDeleteDialog_clientV5_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetDeleteDialog_clientV5_graphql.node, convertFragment, fRef);
}

var ClientFragment_buyerNeedMatchingType_decode = MyClientsWidgetDeleteDialog_clientV5_graphql.Utils.buyerNeedMatchingType_decode;

var ClientFragment_buyerNeedMatchingType_fromString = MyClientsWidgetDeleteDialog_clientV5_graphql.Utils.buyerNeedMatchingType_fromString;

var ClientFragment_forSalePropertyMatchingType_decode = MyClientsWidgetDeleteDialog_clientV5_graphql.Utils.forSalePropertyMatchingType_decode;

var ClientFragment_forSalePropertyMatchingType_fromString = MyClientsWidgetDeleteDialog_clientV5_graphql.Utils.forSalePropertyMatchingType_fromString;

var ClientFragment_rentalNeedMatchingType_decode = MyClientsWidgetDeleteDialog_clientV5_graphql.Utils.rentalNeedMatchingType_decode;

var ClientFragment_rentalNeedMatchingType_fromString = MyClientsWidgetDeleteDialog_clientV5_graphql.Utils.rentalNeedMatchingType_fromString;

var ClientFragment_rentalPropertyMatchingType_decode = MyClientsWidgetDeleteDialog_clientV5_graphql.Utils.rentalPropertyMatchingType_decode;

var ClientFragment_rentalPropertyMatchingType_fromString = MyClientsWidgetDeleteDialog_clientV5_graphql.Utils.rentalPropertyMatchingType_fromString;

var ClientFragment = {
  buyerNeedMatchingType_decode: ClientFragment_buyerNeedMatchingType_decode,
  buyerNeedMatchingType_fromString: ClientFragment_buyerNeedMatchingType_fromString,
  forSalePropertyMatchingType_decode: ClientFragment_forSalePropertyMatchingType_decode,
  forSalePropertyMatchingType_fromString: ClientFragment_forSalePropertyMatchingType_fromString,
  rentalNeedMatchingType_decode: ClientFragment_rentalNeedMatchingType_decode,
  rentalNeedMatchingType_fromString: ClientFragment_rentalNeedMatchingType_fromString,
  rentalPropertyMatchingType_decode: ClientFragment_rentalPropertyMatchingType_decode,
  rentalPropertyMatchingType_fromString: ClientFragment_rentalPropertyMatchingType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use$4,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function MyClientsWidgetDeleteDialog(props) {
  var onSuccess_ = props.onSuccess;
  var onCancel = props.onCancel;
  var isOpen = props.isOpen;
  var client = use$4(props.client);
  var match;
  switch (client.__typename) {
    case "Buyer" :
        match = [
          "Buyer",
          "buyer need",
          client.canDelete
        ];
        break;
    case "Landlord" :
        match = [
          "Landlord",
          "property",
          client.canDelete
        ];
        break;
    case "Renter" :
        match = [
          "Renter",
          "rental need",
          client.canDelete
        ];
        break;
    case "Seller" :
        match = [
          "Seller",
          "property",
          client.canDelete
        ];
        break;
    case "__unselected" :
        match = UnselectedUnionMemberError.raise("Unselected  " + client._0);
        break;
    
  }
  var canDelete = match[2];
  var entityTypeLabel = match[1];
  var clientTypeLabel = match[0];
  var visibility;
  switch (client.__typename) {
    case "Buyer" :
        var tmp = client.buyerNeed.matchingType;
        visibility = (tmp === "BROADCAST" || tmp === "QUIET") && tmp === "BROADCAST" ? "Public" : "Private";
        break;
    case "Landlord" :
        var tmp$1 = client.property.rentalPropertyMatchingType;
        visibility = tmp$1 === "BROADCAST" ? "Public" : "Private";
        break;
    case "Renter" :
        var tmp$2 = client.rentalNeed.matchingType;
        visibility = tmp$2 === "BROADCAST" ? "Public" : "Private";
        break;
    case "Seller" :
        var tmp$3 = client.forSaleProperty.forSalePropertyMatchingType;
        visibility = (tmp$3 === "QUIET" || tmp$3 === "ONE_WAY" || tmp$3 === "BROADCAST" || tmp$3 === "QUIET_ANONYMOUS") && tmp$3 === "BROADCAST" ? "Public" : "Private";
        break;
    case "__unselected" :
        visibility = "Private";
        break;
    
  }
  var match$1 = React.useState(function () {
        return "Idle";
      });
  var setState = match$1[1];
  var state = match$1[0];
  var match$2 = use();
  var deleteForSaleProperty = match$2[0];
  var match$3 = use$1();
  var deleteRentalProperty = match$3[0];
  var match$4 = use$2();
  var deleteBuyerNeed = match$4[0];
  var match$5 = use$3();
  var deleteRentalNeed = match$5[0];
  var match$6 = SystemMessages.useSystemMessages();
  var addMessage = match$6.addMessage;
  var onSuccess = function () {
    addMessage(SystemMessages.Message.make(V4(), "info", "The client was deleted.", 5000, undefined, undefined));
    onSuccess_();
  };
  var connections = Core__Option.getOr(Core__Option.map(props.connectionId, (function (id) {
              return [id];
            })), []);
  var onConfirm = function () {
    setState(function (param) {
          return "Submitting";
        });
    switch (client.__typename) {
      case "Buyer" :
          deleteBuyerNeed({
                connections: connections,
                input: {
                  id: client.buyerNeed.id
                }
              }, undefined, undefined, undefined, (function (response, param) {
                  var match = response.deleteBuyerNeed;
                  if (match !== undefined) {
                    if (match.__typename === "BuyerNeedDeleted") {
                      return onSuccess();
                    } else {
                      return setState(function (param) {
                                  return "Error";
                                });
                    }
                  } else {
                    return setState(function (param) {
                                return "Error";
                              });
                  }
                }), (function (param) {
                  setState(function (param) {
                        return "Error";
                      });
                }), undefined);
          break;
      case "Landlord" :
          deleteRentalProperty({
                connections: connections,
                input: {
                  id: client.property.id
                }
              }, undefined, undefined, undefined, (function (response, param) {
                  var match = response.deleteRentalProperty;
                  if (match !== undefined) {
                    if (match.__typename === "RentalPropertyDeleted") {
                      return onSuccess();
                    } else {
                      return setState(function (param) {
                                  return "Error";
                                });
                    }
                  } else {
                    return setState(function (param) {
                                return "Error";
                              });
                  }
                }), (function (param) {
                  setState(function (param) {
                        return "Error";
                      });
                }), undefined);
          break;
      case "Renter" :
          deleteRentalNeed({
                connections: connections,
                input: {
                  id: client.rentalNeed.id
                }
              }, undefined, undefined, undefined, (function (response, param) {
                  var match = response.deleteRentalNeed;
                  if (match !== undefined) {
                    if (match.__typename === "RentalNeedDeleted") {
                      return onSuccess();
                    } else {
                      return setState(function (param) {
                                  return "Error";
                                });
                    }
                  } else {
                    return setState(function (param) {
                                return "Error";
                              });
                  }
                }), (function (param) {
                  setState(function (param) {
                        return "Error";
                      });
                }), undefined);
          break;
      case "Seller" :
          deleteForSaleProperty({
                connections: connections,
                input: {
                  id: client.forSaleProperty.id
                }
              }, undefined, undefined, undefined, (function (response, param) {
                  var match = response.deleteForSaleProperty;
                  if (match !== undefined) {
                    if (match.__typename === "ForSalePropertyDeleted") {
                      return onSuccess();
                    } else {
                      return setState(function (param) {
                                  return "Error";
                                });
                    }
                  } else {
                    return setState(function (param) {
                                return "Error";
                              });
                  }
                }), (function (param) {
                  setState(function (param) {
                        return "Error";
                      });
                }), undefined);
          break;
      case "__unselected" :
          UnselectedUnionMemberError.raise("Unselected client " + client._0);
          break;
      
    }
  };
  if (canDelete !== undefined && !canDelete) {
    return JsxRuntime.jsx(DialogV5.make, {
                title: "Unable to delete " + clientTypeLabel,
                isOpen: isOpen,
                ariaLabel: "Unable to delete " + clientTypeLabel,
                onDismiss: onCancel,
                children: JsxRuntime.jsxs(JsxRuntime.Fragment, {
                      children: [
                        JsxRuntime.jsx("p", {
                              children: "It's not possible to delete a client who has been invited or registered for client access.",
                              className: "leading-6"
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                                    onClick: (function (param) {
                                        onCancel();
                                      }),
                                    children: "OK"
                                  }),
                              className: "flex gap-4 mt-4 justify-end"
                            })
                      ]
                    })
              });
  }
  var tmp$4;
  switch (state) {
    case "Idle" :
    case "Submitting" :
        tmp$4 = null;
        break;
    case "Error" :
        tmp$4 = JsxRuntime.jsx(Alert.$$Error.make, {
              title: "An error occurred while deleting the client. Please try again."
            });
        break;
    
  }
  return JsxRuntime.jsx(ConfirmDialog.make, {
              title: "Delete " + clientTypeLabel + "?",
              ariaLabel: "Confirm Delete " + clientTypeLabel,
              body: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("p", {
                            children: visibility === "Public" ? "Other agents can no longer find your client's " + entityTypeLabel + " nor see any matches they might have. Conversations that have already been started can continue." : "Other agents can no longer see any matches they might have with your client's " + entityTypeLabel + ". Conversations that have already been started can continue.",
                            className: "leading-6"
                          }),
                      JsxRuntime.jsx("br", {}),
                      JsxRuntime.jsx("p", {
                            children: "THIS CANNOT BE UNDONE",
                            className: "font-bold"
                          }),
                      tmp$4
                    ],
                    className: "space-y-2"
                  }),
              isOpen: isOpen,
              onCancel: onCancel,
              cancelButton: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                    onClick: (function (param) {
                        onCancel();
                      }),
                    children: Caml_option.some("No, Keep " + clientTypeLabel)
                  }),
              confirmButton: JsxRuntime.jsx(ButtonsV5.DangerButton.make, {
                    onClick: (function (param) {
                        onConfirm();
                      }),
                    disabled: state === "Submitting",
                    children: Caml_option.some("Yes, Delete " + clientTypeLabel)
                  })
            });
}

var make = MyClientsWidgetDeleteDialog;

exports.Mutations = Mutations;
exports.ClientFragment = ClientFragment;
exports.make = make;
/* commitMutation Not a pure module */
